@import '../../../../../../constants/spacing.module.less';

.plan-upgrade-banner-wrapper {
  height: 225px;
  display: flex;
  border-radius: @space-8;
  align-items: flex-start;
  justify-content: space-between;
  background-color: var(--white);
  border: 1px solid var(--gray-DFE4E8);

  .content-and-button-wrapper {
    display: flex;
    padding: @space-16;
    align-self: stretch;
    flex-direction: column;
    justify-content: space-between;
  }

  .button-wrapper {
    display: flex;
  }
}

.image-wrapper {
  width: 384px;
  text-align: center;
  align-self: stretch;
  align-content: center;
  background-color: var(--green-E5F6EE);
}

.content-wrapper {
  h3 {
    margin-top: 0;
  }
}

.upgrade-banner-button {
  display: flex;
  align-items: center;
  margin-right: @space-8;

  .icon {
    width: @space-12;
    height: @space-12;
    margin-right: @space-4;
  }
}

.enable-inventory-button {
  font-weight: 400;
  color: var(--blue-11003A);
  border-color: var(--blue-11003A);
}
